

import React, { useEffect } from 'react';

const Referral= ({ url }) => {

    useEffect(() => {
        if (url) {
          window.location.href = url;
        }
      }, [url]);

      
    return ( 
        <></>
     );
}
 
export default Referral;